import RizdvonikiContainer from "../features/lending/Rizdvoniki";

const Rizdvoniki = () => <RizdvonikiContainer />;

export default Rizdvoniki;
